import 'alpinejs'
import algoliasearch from 'algoliasearch/lite'
import instantsearch from 'instantsearch.js'
import { searchBox, hits } from 'instantsearch.js/es/widgets'
import { connectSearchBox } from 'instantsearch.js/es/connectors'
import 'instantsearch.css/themes/reset-min.css'


const search = instantsearch({
  indexName: process.env.ALGOLIAINDEX,
  searchClient: algoliasearch(
    process.env.ALGOLIAAPPID,
    process.env.ALGOLIASEARCHAPI,
  ),
  numberLocale: 'fr',
});

const getSearchBox = function() {
  const isHidden = (el) => {
    const style = window.getComputedStyle(el);
    return ((style.display === 'none') || (style.visibility === 'hidden'))
  }

  const all = document.getElementsByTagName("*");
  for (const el of all) {
    if (!isHidden(el) && el.querySelector(".searchbox")) return el.querySelector(".searchbox");
  }
}

const renderSearchBox = (renderOptions, isFirstRender) => {
  const { query, refine, widgetParams } = renderOptions

  const container =  document.querySelector(widgetParams.container)
  const tpl = document.querySelector(widgetParams.tpl)

  if (isFirstRender) {
    const form = tpl.content.firstElementChild.cloneNode(true)
    const input = form.querySelector("input")

    input.addEventListener('input', event => {
      refine(event.target.value)
    })

    container.appendChild(form)

    const params = new window.URLSearchParams(window.location.search)
    input.value = params.get("q")
    input.focus()
    refine(input.value)
  }

}

const customSearchBox = connectSearchBox(
  renderSearchBox
)

search.addWidgets([
  customSearchBox({
    container: '#searchbox-sidebar',
    tpl: '#searchbox-sidebar-tpl'
  }),
  customSearchBox({
    container: '#searchbox-mobile',
    tpl: '#searchbox-sidebar-mobile'
  }),  
  hits({
    container: '#hits',
    templates: {
      item(item) {
        const results = []
        results.push(`<div class="article py-4">`)
        results.push(`<h3 class="px-3 article__title"><a class="text-decoration-none" href="${item.url}">${item._highlightResult.title.value}</a></h3>`)

        results.push(`<div class="px-3 article__info">${item.infos}</div>`)

        if (item._highlightResult.authors) {
          results.push(`<div class="px-3 article__authors">`)
          const authors = item._highlightResult.authors
          for (let i = 0; i < authors.length; i++) {
            results.push(`<span>${authors[i].value}</span>`)
            if (i != authors.length - 1) {
              results.push(`,&nbsp;`)
            }
          }
        }

        results.push(`
          <div class="px-3 article__content">${item._snippetResult.content.value}</div>
          </div>
          `)
        return results.join('')
      }
    }
  })  
])

search.start()
